import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api";
// import dummyData from "../../database/resources.json";
import adapter from "./adapter";
import * as config from "./config";
import { generateSliceCore, generateCoreExtraReducers } from "../core/tools";
import apiService from "../api/service";
const { NAME } = config;

const core = generateSliceCore(config);
const app = {
  initialState: {
    _payload: null,
    status: "idle",
    error: "",
    data: [],
    data_options: [],
    data_featured: []
  },
  action: {
    fetchResources: createAsyncThunk(
      `${NAME}/fetchResources`,
      async (options) => {
        const data = await apiService.get(NAME, options);
        return data;
      }
    ),
    fetchFeaturedResources: createAsyncThunk(`${NAME}/fetchFeaturedResources`, async (options) => {
      const data = await apiService.get('resources_featured', options);
      return data;
    }),
  },
};

/** Action - Thunks */
export const { setQuery, setCurrentPage, setSorter } = core.action;
export const { fetchResources, fetchFeaturedResources } = app.action;

/** Reducer - Extra Reducers */
const coreExtraReducers = generateCoreExtraReducers(core.action);

export const resourcesSlice = createSlice({
  name: NAME,
  initialState: {
    ...core.initialState,
    ...app.initialState,
  },
  reducers: {
    setStatus(state, action) {
      state.status = action.payload;
    },
    setPageItems(state, action) {
      state.pageItems = action.payload;
    },
  },
  extraReducers: {
    ...coreExtraReducers,

    // Resources | Bulk
    [fetchResources.pending]: (state) => {
      state.status = "loading";
    },
    [fetchResources.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      const { results, count } = action.payload
      const data = api.resources_available
      ? adapter.responseBodyToRender(results)
      : results;
      state.data = data
      state.data_options = adapter.responseBodyToOptions(results);
      state.totalItems = count;
      state.pageItems = data
    },
    [fetchResources.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },

    [fetchFeaturedResources.fulfilled]: (state, action) => {
      state.data_featured_payload = action.payload;
      state.data_featured = adapter.responseBodyToRender(action.payload);
    }
  },
});

export const { setStatus, setPageItems } = resourcesSlice.actions;

export const resourcesActions = {
  ...resourcesSlice.actions,
  ...core.action,
  ...app.action,
};

export default resourcesSlice.reducer;
